import React from 'react';
import TextInput from './fields/TextInput';
import SubmitButton from './fields/SubmitButton';
import { Divider } from '@mui/material';
import SelectInput from './fields/SelectInput';
import currency from 'utils/currency';

export default function AccountForm({ isUpdate, loading, }) {
  const typeOptions = [
    { value: "cash", label: "Cash" },
    { value: "bank", label: "Bank" }
  ];

  return (
    <>
      <TextInput field="name" label="Name" />
      <SelectInput field="type" label="Type" options={typeOptions} />
      <SelectInput disabled={isUpdate} field="currency" label="Currency" options={currency.options} />
      <Divider />
      <SubmitButton loading={loading}>Submit</SubmitButton>
    </>
  );
}
